export const  EmployeeWeekOffUploadsColumns = [
    "EmployeeCode",
    "EmployeeType",
    "WeekOfDay",
    
];
